var startup = __webpack_require__.x;
__webpack_require__.x = () => {
	var result = startup();
	__webpack_require__.E(336);
	return result;
};